import { AffiliateApi } from "@/api/affiliates";
import { QueryKey } from "@/utils";
import { useInfiniteQuery } from "@tanstack/react-query";

export const useGetAcquiredUsersQuery = ({
  userId,
  page,
  perPage,
}: {
  userId: string;
  page: number;
  perPage: number;
}) => {
  const { data, isPending, fetchNextPage } = useInfiniteQuery({
    queryKey: [QueryKey.AFFILIATE_ACQUIRED_USERS, userId],
    queryFn: ({ pageParam }: { pageParam: number }) => {
      return AffiliateApi.getAcquiredUsers({
        perPage: perPage,
        page: pageParam,
        id: userId,
      });
    },
    enabled: !!userId,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.meta.page + 1;
      return nextPage <= lastPage.meta.totalPages ? nextPage : undefined;
    },
    select: ({ pages }) => {
      return pages.flatMap((data) => data)[page];
    },
  });

  return {
    acquiredUsers: data,
    isAcquiredUsersLoading: isPending,
    fetchNextAcquiredUsers: fetchNextPage,
  };
};
